import React, { ReactNode } from 'react';

import { useMediaQuery } from '@mui/material';
import theme from 'theme';

export default function PageContent({ children }: { children?: ReactNode | ReactNode[] }) {
    const small = useMediaQuery(theme.breakpoints.down('md'));

    return <div style={{ marginBottom: small ? 15 : 69, flexGrow: 1 }}>{children}</div>;
}
